import React, { useState } from 'react';
import { Container, Table, Form, Button, Row, Col, Badge } from 'react-bootstrap';
import UPITransferModal from '../../../components/modals/UPITransferModal';

const UPITransfer = () => {
  // Mock data for UPI transfers
  const [data, setData] = useState([
    {
      transactionDate: '2024-01-15',
      name: 'Rajesh Kumar',
      phone: '9876543210',
      accountNumber: '1234567890',
      amount: 5000,
      status: 'Success'
    },
    {
      transactionDate: '2024-01-16',
      name: 'Amit Sharma',
      phone: '9123456789',
      accountNumber: '2345678901',
      amount: 2500,
      status: 'Pending'
    },
    {
      transactionDate: '2024-01-17',
      name: 'Priya Singh',
      phone: '9988776655',
      accountNumber: '3456789012',
      amount: 7500,
      status: 'Success'
    },
    {
      transactionDate: '2024-01-18',
      name: 'Suresh Patel',
      phone: '9876512345',
      accountNumber: '4567890123',
      amount: 1200,
      status: 'Failed'
    },
    {
      transactionDate: '2024-01-19',
      name: 'Neha Verma',
      phone: '9123467890',
      accountNumber: '5678901234',
      amount: 3500,
      status: 'Success'
    }
  ]);

  // State management
  const [mobileNumber, setMobileNumber] = useState('');
  const [mobileError, setMobileError] = useState('');
  
  // Modal state
  const [showModal, setShowModal] = useState(false);

  // Column definitions
  const columns = [
    { key: 'transactionDate', label: 'Date' },
    { key: 'name', label: 'Name' },
    { key: 'phone', label: 'Mobile Number' },
    { key: 'accountNumber', label: 'Account Number' },
    { key: 'amount', label: 'Amount' },
    { key: 'status', label: 'Status' }
  ];

  // Validate phone number
  const validatePhone = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  // Handle mobile number change
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only digits
    if (value.length <= 10) {
      setMobileNumber(value);
      setMobileError('');
    }
  };

  // Handle submit mobile number
  const handleSubmitMobile = () => {
    if (!mobileNumber) {
      setMobileError('Please enter mobile number');
      return;
    }
    
    if (!validatePhone(mobileNumber)) {
      setMobileError('Invalid mobile number (10 digits starting with 6-9)');
      return;
    }

    setMobileError('');
    setShowModal(true);
  };

  // Handle modal close
  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Handle transfer submission
  const handleTransferSubmit = (transferData) => {
    // Add new transaction to the top of the list
    const newTransaction = {
      transactionDate: transferData.transactionDate,
      name: transferData.beneficiaryName,
      phone: mobileNumber,
      accountNumber: 'N/A',
      amount: parseFloat(transferData.amount),
      status: 'Pending'
    };
    
    setData([newTransaction, ...data]);
    
    // Clear mobile number input
    setMobileNumber('');
    
    console.log('UPI Transfer Submitted:', transferData);
  };

  // Get status badge variant
  const getStatusVariant = (status) => {
    switch(status) {
      case 'Success': return 'success';
      case 'Pending': return 'warning';
      case 'Failed': return 'danger';
      default: return 'secondary';
    }
  };

  return (
    <Container fluid className="p-4">
      <div className="user-table-container">
        {/* Header with Title */}
        <Row className="mb-4">
          <Col>
            <h4 className="mb-0" style={{ color: '#1e293b', fontWeight: '700', fontSize: '1.5rem' }}>
              <i className="bi bi-bank me-2"></i>
              UPI Transfer
            </h4>
          </Col>
        </Row>

        {/* Mobile Number Input Section */}
        <Row className="mb-4">
          <Col lg={6} md={8} sm={12}>
            <Form.Group>
              <Form.Label style={{ fontWeight: '600', color: '#1e293b' }}>
                Enter Mobile Number <span className="text-danger">*</span>
              </Form.Label>
              <div className="d-flex gap-2">
                <Form.Control
                  type="tel"
                  placeholder="Enter 10-digit mobile number"
                  value={mobileNumber}
                  onChange={handleMobileChange}
                  isInvalid={!!mobileError}
                  maxLength={10}
                  style={{ fontSize: '1rem' }}
                />
                <Button 
                  onClick={handleSubmitMobile}
                  disabled={mobileNumber.length !== 10}
                  className="btn-outline-submit"
                  style={{ 
                    minWidth: '120px',
                    fontWeight: '600',
                    background: 'transparent',
                    border: '2px solid #667eea',
                    color: '#667eea',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    if (!e.currentTarget.disabled) {
                      e.currentTarget.style.background = '#667eea';
                      e.currentTarget.style.color = 'white';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#667eea';
                  }}
                >
                  Submit
                </Button>
              </div>
              {mobileError && (
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                  {mobileError}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
        </Row>

        {/* Table */}
        <div className="table-responsive" style={{ background: '#f0f2f5', borderRadius: '12px', padding: '0' }}>
          <Table bordered hover className="modern-table" style={{ background: '#f0f2f5' }}>
            <thead style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
              <tr>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <tr key={index} style={{ background: '#f0f2f5' }}>
                    <td>{row.transactionDate}</td>
                    <td>{row.name}</td>
                    <td>{row.phone}</td>
                    <td>{row.accountNumber}</td>
                    <td><strong>₹{row.amount.toLocaleString()}</strong></td>
                    <td>
                      <Badge bg={getStatusVariant(row.status)}>
                        {row.status}
                      </Badge>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center py-4">
                    <i className="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                    <span className="text-muted">No transactions found</span>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* UPI Transfer Modal */}
        <UPITransferModal
          show={showModal}
          handleClose={handleCloseModal}
          mobileNumber={mobileNumber}
          onSubmit={handleTransferSubmit}
        />
      </div>
    </Container>
  );
};

export default UPITransfer;

